// extracted by mini-css-extract-plugin
export default {"container":"ForgotPasswordSection_container__Afubm","root":"ForgotPasswordSection_root__tnLS0","signInHeader":"ForgotPasswordSection_signInHeader__0ScSk"};